// extracted by mini-css-extract-plugin
module.exports = {"wish-list-icon":"WishList_wish-list-icon__SCso4"};